import script from "./AutoCompleteSearchBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoCompleteSearchBox.vue?vue&type=script&setup=true&lang=js"

import "./AutoCompleteSearchBox.vue?vue&type=style&index=0&id=0cc871e7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc871e7"]])

export default __exports__